export const OTP_RESEND_ERROR = "Failed to resend OTP. Please try again.";
export const USER_UPDATE_ERROR = "Failed to update user information. Please try again.";
export const INVITE_RESENT_SUCCESS = "Resent invite to {firstname} {lastname} to add them to your organization.";
export const USER_DETAILS_UPDATED_SUCCESS = "User details of '{fullname}' has been updated";
export const USER_DETAILS_UPDATE_FAILED = "User details of '{fullname}' couldn't be updated";
export const USER_DETAILS_UPDATED = "User information for {fullname} has been updated";
export const GROUPS_SITES_UPDATE_FAILED = "Failed to update groups and sites.";
export const FAILED_TO_SEND_OTP = "Failed to send OTP to email. Please try again.";
export const FAILED_TO_RESEND_INVITE = "Failed to resend invite. Please try again.";
export const PHONE_UPDATE_SUCCESS = "Phone number updated successfully. All SMS notifications will now be sent to the updated number.";
export const INVALID_OTP_ERROR = "Invalid or expired OTP. Phone number not updated";

/* Regex */
export const OTP_DIGIT_REGEX = /^\d*$/;
export const NON_DIGIT_REGEX = /\D/g;
export const NON_NUMERIC_REGEX = /[^0-9]/g;
